type AiBuilderQuizTarget = {
  id: string;
};

type AiBuilderQuestionTargetRef = {
  questionId: string;
  quizNumber: number;
};

export const getCompletionScrollTargetQuizId = (quizIds: readonly string[]) => {
  return quizIds[0];
};

export const getQuizIdByJumpLinkNumber = (
  quizList: readonly AiBuilderQuizTarget[],
  quizNumber: number,
) => {
  return quizList[quizNumber - 1]?.id;
};

export const getQuizIdByQuestionRef = (
  quizList: readonly AiBuilderQuizTarget[],
  questionRef: AiBuilderQuestionTargetRef,
) => {
  return (
    quizList.find(quiz => quiz.id === questionRef.questionId)?.id ??
    getQuizIdByJumpLinkNumber(quizList, questionRef.quizNumber)
  );
};
